import Vue from 'vue'
import template from './index.pug'

export default Vue.extend({
  template: template(),
  created() {
    window.scrollTo(0, 0)
  }
})
